import { PixType } from './type'
import Visual from './Visual'

const Pix = ({ orderId }: PixType) => {
  return <Visual orderId={orderId} />
}

export default Pix
